import { Button, ButtonProps } from '../02-atoms/Button';
import { Logo, LogoProps } from '../02-atoms/Logo';

export interface SocialFollowProps {
  /** The follow links */
  items: ButtonProps[];
  /** The optional logo */
  logo?: LogoProps;
  /** Additional class */
  className?: string;
  /** Click handler */
  onClick?: () => void;
}

/** A block rendering multiple links to social media platforms */
export const SocialFollow = ({
  items,
  logo,
  className,
  ...props
}: SocialFollowProps) => {
  return (
    <div className={['social-follow', className].join(' ')} {...props}>
      <ul className="social-follow__links">
        {items.map((item, i) => {
          return (
            <li key={i} className="social-follow__link">
              <Button type="primary" {...item} />
            </li>
          );
        })}
        {logo && (
          <Logo className="social-follow__logo" individual={true} {...logo} />
        )}
      </ul>
    </div>
  );
};
